import { notify } from 'reapop'
import { subscriptionLogConstants } from '../constants'
import { subscriptionLogService } from '../services'

export const subscriptionLogActions = {
    getSubscriptionLogs,
}
function getSubscriptionLogs(data) {
    return dispatch => {
        dispatch(request())

        subscriptionLogService.getSubscriptionLogs(data)
            .then(
                result => dispatch(success(result)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(notify({ position: "tc", dismissible: false, message: error.toString(), status: "error" }))
                }
            )
    }

    function request() { return { type: subscriptionLogConstants.GET_SUBSCRIPTION_LOG_REQUEST } }
    function success(result) { return { type: subscriptionLogConstants.GET_SUBSCRIPTION_LOG_SUCCESS, result } }
    function failure(error) { return { type: subscriptionLogConstants.GET_SUBSCRIPTION_LOG_FAILURE, error } }
}
